module.exports = __webpack_public_path__ + "wf.svg?c942b078f06fd4e28d7a513cbcceda65";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/wf.svg
// module id = 1418
// module chunks = 27